// extracted by mini-css-extract-plugin
module.exports = {"loginCodeHolder":"LoginCodeMenu_loginCodeHolder__2u_9c","bookingLinkHolder":"LoginCodeMenu_bookingLinkHolder__REBBH"};